import React from 'react';
import { useQuery } from 'react-query';
import { productServices } from '../../api/services/products';
import { Modal } from 'antd';
import { Spinner } from 'react-bootstrap';
import { formatCurrencyEuro, formatDate } from '../../helpers/format';
import { Area, CartesianGrid, ComposedChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export const HistoricalModal = ({ open, handleClose, item }) => {

    const { data, isFetching, isError } = useQuery(
        "historical",
        () => productServices.getHistorical(item),
        {
            refetchOnWindowFocus: false,
            enabled: open && item != null
        }
    );

    return (
        <Modal title={
                <div style={{textAlign: 'center', fontSize: 22, marginTop: 20}}>
                    Histórico
                </div>}
                footer={null}
                bodyStyle={{padding: '24px 0px 0px 0px'}}
                open={open}
                onOk={() => handleClose()}
                onCancel={() => handleClose()}>
            <div>
                <div style={{padding: '0px 24px 0px 0px'}}>
                    {
                        isFetching ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="alert alert-danger" role="alert">
                                <Spinner animation="border" variant="danger" role="status" className="me-2"/>Cargando...</div>
                            </div>
                        ) : (isError) ? ( 
                            <div>
                                <div className="alert alert-danger mt-3 ml-3" role="alert">
                                    Se ha producido un error, vuelve a intentarlo
                                </div>
                            </div>
                        ) : data ? (
                            <div style={{width: '100%'}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <ComposedChart
                                        data={data.response.map(d => ({...d,"valorLiquidativo": +d.valorLiquidativo})).sort((a, b) => new Date(a.fecha) - new Date(b.fecha))}
                                        >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <Tooltip labelFormatter={(label) => formatDate(label)} formatter={(label) => formatCurrencyEuro(label)} />
                                        <XAxis dataKey="fecha" tickFormatter={(tick) => formatDate(tick)} />
                                        <YAxis 
                                            type="number"
                                            tickFormatter={(tick) => tick.toFixed(2)}
                                            domain={['dataMin', 'dataMax']} />
                                        <Area key={1} name='Valor liquidativo' dataKey="valorLiquidativo" fill="#ebd1d1" stroke="#9c1918" />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </div>
                        ) : ''
                    }
                </div>
                <div style={{height: 84, display: 'flex', justifyContent: 'center', backgroundColor: '#e8e8e8', paddingBottom: 24, paddingTop: 20}}>
                    <button style={{backgroundColor: '#ec0000', borderColor: '#ec0000', color: 'white', fontWeight: 600, borderRadius: 25, minWidth: 100}} onClick={() => handleClose()} className="contratarButton">OK</button>
                </div>
            </div>
        </Modal>
    )
}
